import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const Header = styled.div``;

export const Title = styled.p`
    display: flex;
    flex-direction: column;
    font-size: 32px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.gray.gray_800};

    span{
        color: ${(props) => props.theme.colors.gray.gray_500};
        font-size: 14px;
        font-weight: 400;
    }
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;